<div class="group-all-btn" (click)="toggleAllGroups()">
  <span class="icon" [ngClass]="{'ic-plus': !expandedGroups, 'ic-minus': expandedGroups}"></span>
</div>
